import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Dono alag files ko yahan import kiya hai
import generateSlip from "./generateSlip";
import finalSlip from "./finalSlip"; 
import { Sidebar } from '../moderator/Sidebar';
import config from "../../config/config";
import { Navbar } from '../../components/Navbar';

export default function SupplierPayments() {
  const [subcat, setsubcat] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/SupplierDetails/supplierpayment`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        console.log('Supplier payment data:', data);
        setsubcat(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch Supplier Payment", error);
        setsubcat([]);
      }
    };

    fetchData();
  }, []);

  // Updated handlePrint logic
  const handlePrint = async (id, payType) => {
    try {
      const token = localStorage.getItem('token');
      
      // Check if it's a Final Payment
      const isFinal = payType === 'Final Payment';
      
      // Dynamic API endpoint based on payment type
      const endpoint = isFinal 
        ? `${config.baseUrl}/api/supplierDetails/printFinalSlip/${id}` 
        : `${config.baseUrl}/api/supplierDetails/printSlip/${id}`;

      const response = await fetch(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();

      if (data && data.payment) {
        if (isFinal) {
          localStorage.setItem('temp_supplier_final_slip', JSON.stringify(data.payment));
          // Agar payment final hai toh finalslip ki alag file open hogi
          navigate('/printFinalSlip');
        } else {
          // Warna normal generate slip open hogi
          generateSlip(data.payment);
        }
      } else {
        alert("No payment data found.");
      }

    } catch (error) {
      console.error("Error printing slip:", error);
      alert("Failed to generate the slip.");
    }
  };

  const handleDelete = async (id) => {
    if (!id) {
      console.log("Please assign the expense Id");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this payment?")) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/supplierPayment/deleteSupPayment/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      alert(data.message);
      navigate('/SuperAdminDashboard/SupPayment');
    } catch (error) {
      console.log(error);
    }
  };

  return (
      <div className="">
        {/* Main Card Container */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
          
          {/* Header Section */}
          <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-white">
            <div>
              <h1 className="text-2xl font-extrabold text-gray-800">Supplier Payment Details</h1>
            </div>
            <button
              className="bg-indigo-800 text-white px-5 py-2.5 rounded-lg font-bold hover:bg-indigo-700 transition-colors shadow-sm flex items-center"
              onClick={() => navigate("/supplier/new-payment")}
            >
              <span className="mr-2">+</span>New Payment
            </button>
          </div>

          {/* Table Container */}
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 font-bold text-center">S.no</th>
                  <th className="px-6 py-4 font-bold">Supplier Name</th>
                  <th className="px-6 py-4 font-bold">Type</th>
                  <th className="px-6 py-4 font-bold">Category</th>
                  <th className="px-6 py-4 font-bold text-center">Pay Type</th>
                  <th className="px-6 py-4 font-bold text-right">Amount</th>
                  <th className="px-6 py-4 font-bold text-center">No. of Animals</th>
                  <th className="px-6 py-4 font-bold">Remarks</th>
                  <th className="px-6 py-4 font-bold text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {Array.isArray(subcat) && subcat.length > 0 ? (
                  subcat.map((sub_cat, index) => (
                    <tr key={index} className="hover:bg-blue-50/50 transition-colors">
                      <td className="px-6 py-4 text-center font-medium text-gray-500">{index + 1}</td>
                      <td className="px-6 py-4 font-semibold text-gray-800">{sub_cat.supp_name}</td>
                      <td className="px-6 py-4 text-gray-600">{sub_cat.category_name}</td>
                      <td className="px-6 py-4 text-gray-600">{sub_cat.sub_category_name}</td>
                      <td className="px-6 py-4 text-center">
                        <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${
                          sub_cat.paytype === 'Cash' 
                            ? 'bg-green-100 text-green-700' 
                            : sub_cat.paytype === 'Final Payment'
                            ? 'bg-blue-100 text-blue-700' 
                            : 'bg-purple-100 text-purple-700'
                        }`}>
                          {sub_cat.paytype}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-gray-900">
                        {sub_cat.pay_amount}
                      </td>
                      <td className="px-6 py-4 text-center font-medium text-gray-700">
                        {sub_cat.no_of_animal}
                      </td>
                      <td className="px-6 py-4 text-gray-500 italic max-w-xs truncate">
                        {sub_cat.remarks || "-"}
                      </td>
                      <td className="px-6 py-4 text-center">
                        <div className="flex justify-center space-x-2">
                          <button
                            className="bg-emerald-500 text-white px-3 py-1.5 rounded text-xs font-bold hover:bg-emerald-600 transition-all shadow-sm"
                            onClick={() => handlePrint(sub_cat.pay_id, sub_cat.paytype)} 
                          >
                            Print
                          </button>
                          <button
                            className="bg-rose-500 text-white px-3 py-1.5 rounded text-xs font-bold hover:bg-rose-600 transition-all shadow-sm"
                            onClick={() => handleDelete(sub_cat.pay_id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-20 text-gray-400 font-medium bg-gray-50/30">
                      No payment records available at the moment.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Table Footer / Summary */}
          <div className="bg-gray-50 p-4 border-t border-gray-100">
            <p className="text-xs text-gray-400 font-bold uppercase tracking-widest">
              Showing {subcat.length} Records
            </p>
          </div>
        </div>
      </div>
  );
}